import { Platform } from '@ionic/angular';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router, Navigation } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProductStore } from 'src/app/stores/product.store';
import { log } from 'console';
import { imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-category-header',
  templateUrl: './category-header.component.html',
  styleUrls: ['./category-header.component.scss'],
})
export class CategoryHeaderComponent implements OnInit, AfterViewInit {
  @Input() category;
  selectedCategory: null
  imageUrl = imageUrl;
  // round photo + tint per main category id (assets/images/categories/bar-<id>.png);
  // categories not listed fall back to their admin icon
  barArt: { [id: number]: { tint: string } } = {
    1: { tint: '#fde8ee' },
    2: { tint: '#fde9e6' },
    3: { tint: '#e5effd' },
    4: { tint: '#e3f6e8' },
    5: { tint: '#fdf6e3' },
  };
  @ViewChild('categoryList') categoryList: ElementRef<HTMLElement>;
  canScrollLeft = false;
  canScrollRight = false;

  // hover mega menu
  openCat: any = null;
  activeSub: any = null;
  subProducts: { [subId: number]: any[] } = {};
  private closeTimer: any;
  constructor(
    public translate: TranslateService,
    private route: Router,
    public platform:Platform,
    private productStore: ProductStore
  ) { }

  ngOnInit() { }

  // top-level categories only (the list also contains sub-categories, which have a parent)
  get mainCategories() {
    return (this.category?.data || []).filter((item) => !item.parent);
  }

  ngAfterViewInit() {
    // wait for the category list to render before measuring it
    setTimeout(() => this.updateScrollState(), 300);
  }

  @HostListener('window:resize')
  updateScrollState() {
    const el = this.categoryList?.nativeElement;
    if (!el) return;
    this.canScrollLeft = el.scrollLeft > 0;
    this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  }

  scrollCategories(direction: number) {
    const el = this.categoryList?.nativeElement;
    if (!el) return;
    el.scrollBy({ left: direction * el.clientWidth * 0.7, behavior: 'smooth' });
  }

  selectCat(item) {
    this.selectedCategory = item.slug
  }
  
  selectCatweb(Id:any){
    this.openCat = null;
    this.route.navigate([`/category/${Id}`]);
  }

  // ---------- mega menu ----------
  // sub-categories of a main category (nested list or flat list with parent ids)
  subsOf(main) {
    if (!main) return [];
    if (main.child_category?.length) return main.child_category;
    return (this.category?.data || []).filter((item) => item.parent === main.id);
  }

  openMenu(main) {
    clearTimeout(this.closeTimer);
    if (this.openCat?.id === main.id) return;
    this.openCat = main;
    this.setSub(this.subsOf(main)[0]);
  }

  // small delay so the pointer can travel from the bar into the panel
  scheduleClose() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => (this.openCat = null), 200);
  }

  cancelClose() {
    clearTimeout(this.closeTimer);
  }

  // select a sub-category and load a few of its products (cached)
  async setSub(sub) {
    this.activeSub = sub;
    if (!sub || this.subProducts[sub.id]) return;
    const main = this.openCat;
    try {
      const resp = await this.productStore.getProducts({
        category: main.id,
        sub_category: sub.id,
        condition: 0,
        page: 1,
        paginate: 4,
      });
      this.subProducts[sub.id] = (resp?.data?.product || []).slice(0, 4);
    } catch (error) {
      this.subProducts[sub.id] = [];
    }
  }

  goCategory(slug: string) {
    this.openCat = null;
    this.route.navigate([`/category/${slug}`]);
  }

  goProduct(slug: string) {
    this.openCat = null;
    this.route.navigate([`/product/${slug}`]);
  }
}
